<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Produtos e Serviços/SubGrupos </label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            v-if="isAllowed(6)"
            color="info"
            to="/subGrupoProduto/criar"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="subGruposProduto.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="subGruposProduto.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(6)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { downloadListaSubGrupoProduto } from "../../../services/grupoProdutoService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listaSubGrupos",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      headers: [
        {
          text: "Id",
          align: "start",
          value: "id",
        },
        { text: "Descrição", value: "descricao" },
        { text: "Grupo", value: "grupoProduto" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("grupoProduto", ["subGruposProduto"]),
    filteredList() {
      if (this.showAtivo === false) {
        return this.subGruposProduto
          .filter((sg) => {
            return sg.ativo === true;
          }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        return this.subGruposProduto.sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("grupoProduto", ["atualizarSubGruposProduto", "atualizarSubGrupoProduto"]),
    editar(grupo) {
      this.atualizarSubGrupoProduto(grupo);
      if (this.isAllowed(6)) {
        this.$router.push(`/subGrupoProduto/editar`);
      } else {
        this.$router.push(`/subGrupoProduto/ver`);
      }
    },
    baixarlista() {
      downloadListaSubGrupoProduto();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarSubGruposProduto();
      this.loading = false;
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
  },
  created: function () {
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
